import {Component} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AuthenticateService} from '../../../common/services/Authenticate.service';

declare var $: any;

@Component({
  selector: 'link-account',
  styleUrls: ['./link-account.css'],
  templateUrl: 'link-account.component.html',
})
export class LinkAccountComponent {
  datas: any = [];
  loginForm: FormGroup;
  model: any = {};
  token_link: string = ''

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private authenticateService: AuthenticateService
  ) {
  }

  ngOnInit() {
    // if (!this.token_link) {
    //   this.toastr.warning("Đăng nhập để liên kết tài khoản", "", {
    //     timeOut: 5000,
    //   });
    //   this.router.navigate(["/login"]);
    // }
  }

  onSubmit(data) {
    let body = {
      usernameQrCode:
        data.username && data.username.trim() !== '' ? data.username.trim() : '',
      passwordQrCode:
        data.oldPassword && data.oldPassword.trim() !== '' ? data.oldPassword.trim() : '',
      phoneNumberIcheck:
        data.phone && data.phone.trim() !== '' ? data.phone.trim() : '',
      passwordIcheck:
        data.password && data.password.trim() !== '' ? data.password.trim() : '',
    };

    this.authenticateService.linkAccount(this.token_link, body).subscribe(
      (res) => {
        this.token_link = res.data ? res.data : ''
        if (res.code == 1) {
          this.toastr.success('Liên kết tài khoản thành công', '', {
            timeOut: 5000,
          });
          this.router.navigate(['/login']);
        } else if (res.code === 8001 || res.code === 8002) {
          this.toastr.warning(res.message, '', {
            timeOut: 5000,
          });
          return this.router.navigate(['/login']);
        } else {
          this.toastr.error(res.message, 'Thất bại', {
            timeOut: 5000,
          });
        }
      },
      (error) => {
        this.token_link = error.data ? error.data : '';
        if (error.code === 8001 || error.code === 8002) {
          this.toastr.warning(error.message, '', {
            timeOut: 5000,
          });
          return this.router.navigate(['/login']);
        }
        this.toastr.error(error.message, 'Thất bại', {
          timeOut: 5000,
        });
      }
    );
  }

  ngOnDestroy() {
    localStorage.removeItem('token_link');
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/auth/link-account.component.ts